module.exports = __webpack_public_path__ + "static/img/payImg.1e581e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/payImg.png
// module id = nDJf
// module chunks = 1